/**
 * Context resolver for investigation case help panel scroll highlight.
 */

export function primaryHelpSectionForTab(activeTab, isUnknown) {
  const map = {
    steps: 'steps',
    evidence: 'evidence',
    suspects: 'suspects',
    transactions: 'transactions',
    kyc: 'kyc',
    outcome: 'outcome',
    smr_form: 'outcome',
    ecdd_tasks: 'outcome',
  }
  if (map[activeTab]) return map[activeTab]
  if (isUnknown && activeTab === 'steps') return 'suspects'
  return 'overview'
}
